module.exports = __webpack_public_path__ + "static/media/tray8.24cdcd34.png";